import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const FormGroup = props => {
  const { className, icon, label, htmlFor, id, subtitle } = props;

  const iconClassName = icon ? `form-group-icon-${icon}` : null;
  const classNamesValue = classNames('form-group', className, iconClassName);

  return (
    <div className={classNamesValue} id={id}>
      {label && (
        <label className="control-label" htmlFor={htmlFor}>
          {label}
        </label>
      )}
      {subtitle && <div className="subtitle">{subtitle}</div>}
      {props.children}
    </div>
  );
};

FormGroup.defaultProps = {
  className: '',
  icon: '',
  label: '',
  htmlFor: '',
  id: null,
  subtitle: null,
};

FormGroup.propTypes = {
  htmlFor: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  icon: PropTypes.string,
  label: PropTypes.node,
  id: PropTypes.string,
  subtitle: PropTypes.string,
};

export default FormGroup;
